import Webinars from './Webinars.vue';

export * from './types';
export default Webinars;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/webinars/index.ts